let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iAsK1")).then(() => parcelRequire('2acNi'));